import { IOsaExecucaoCronogramaModel, IOsaExecucaoFaseAtividadeModel, IOsaExecucaoFaseModel } from './../../../../models/osa-execucao-cronograma-model';
import { OsaExecucaoCronogramaService } from './../../../../services/osa-execucao-cronograma.service';
import { Component, Input, OnInit, } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { ModalAtividadeComponent } from './modal-atividade/modal-atividade.component';
import Swal from 'sweetalert2';
import { BaseFormComponent } from './../../../../shared/components/base-form/base-form.component';

@Component({
  selector: 'app-osa-execucao-aba-cronograma',
  templateUrl: './osa-execucao-aba-cronograma.component.html',
  styleUrls: ['./osa-execucao-aba-cronograma.component.scss']
})

export class OsaExecucaoAbaCronogramaComponent extends BaseFormComponent implements OnInit {

  @Input() public visualizar: boolean;
  public id: number;
  public cronograma: IOsaExecucaoCronogramaModel = {} as IOsaExecucaoCronogramaModel;

  constructor(
    private cronogramaService: OsaExecucaoCronogramaService,
    public toastr: ToastrService,
    public route: ActivatedRoute,
    public router: Router,
    public matDialog: MatDialog,
    public localeService: BsLocaleService,
  ) {
    super(route, toastr, router, localeService, matDialog);
  }

  ngOnInit() {
    this.obterCronograma();
  }

  obterCronograma(): Promise<void> {
    return this.cronogramaService.obterCronograma(this.id)
      .then(res => {
        if (res.sucesso) {
          this.cronograma = res.dados;
        } else {
          throw { mensagem: res.mensagem };
        }
      });
  }

  public excluirAtividade(id: number) {
    Swal.fire({
      title: 'Excluir Atividade',
      text: 'Tem certeza que deseja excluir essa Atividade?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
    })
      .then((res) => {
        if (res.value) {
          this.cronogramaService
            .excluirAtividade(id)
            .then((res) => {
              if (res.sucesso) {
                Swal.fire({
                  toast: true,
                  position: 'top-end',
                  icon: 'success',
                  text: 'Atividade excluída com sucesso.',
                  showConfirmButton: false,
                  timer: 5000,
                  timerProgressBar: true,
                });
              } else {
                this.exibirMensagemAlerta(res.mensagem.descricao);
              }
            })
            .catch((err) => {
              Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
              });
            })
            .finally(() => {
              this.obterCronograma()
            });
        }
      })
  }

  public modalIncluir(element?: IOsaExecucaoFaseModel) {
    try {

      const dialogConfig = new MatDialogConfig();
      dialogConfig.id = 'modal-incluir-atividade';
      dialogConfig.width = '700px';
      dialogConfig.hasBackdrop = true;
      dialogConfig.disableClose = true;
      dialogConfig.data = {
        osaExecucaoId: this.id,
        osaExecucaoFaseId: element?.id,
        atividadeId: null, 
        acao: "incluir",
        confirmou: false
      };
      const modal = this.matDialog.open(ModalAtividadeComponent, dialogConfig);
      modal.afterClosed().subscribe((data) => {
        if (data?.confirmou) {
          this.obterCronograma();
        }
      })
    } catch (err) {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'error',
        text: err.mensagem.descricao,
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
    } finally {
    }
  }

  public modalAlterar(element?: IOsaExecucaoFaseAtividadeModel) {
    try {

      const dialogConfig = new MatDialogConfig();
      dialogConfig.id = 'modal-incluir-atividade';
      dialogConfig.width = '700px';
      dialogConfig.hasBackdrop = true;
      dialogConfig.disableClose = true;
      dialogConfig.data = {
        osaExecucaoId: this.id,
        osaExecucaoFaseId: element?.osaExecucaoFaseId,
        atividadeId: element?.atividadeId, 
        acao: "editar",
        element,
        confirmou: false
      };
      const modal = this.matDialog.open(ModalAtividadeComponent, dialogConfig);
      modal.afterClosed().subscribe((data) => {
        if (data?.confirmou) {
          this.obterCronograma();
        }
      })
    } catch (err) {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'error',
        text: err.mensagem.descricao,
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
    } finally {
    }
  }

  getDiasPlanejadosDivergentes(diasDivergentes?: number | null): string {
    if (diasDivergentes == null || diasDivergentes === 0) return '0';
    return `${diasDivergentes > 0 ? '+' : ''}${diasDivergentes}`;
  }

}

